export default {"src":"/_next/static/media/logotype-sweden.29504629.svg","height":37,"width":125,"blurWidth":0,"blurHeight":0};